import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import {
  deleteBusinessUnit,
  loadAllBusinessUnits,
} from '../../store/global-settings.actions';
import { openDeleteConfirmationDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { BusinessUnitDialogFormComponent } from '../../components/business-unit-form-dialog/business-unit-form-dialog.component';

@Component({
  standalone: false,
  selector: 'app-business-units',
  templateUrl: './business-units.component.html',
  styleUrls: ['./business-units.component.scss'],
})
export class BusinessUnitsComponent {
  constructor(private store: Store<AppState>, private dialog: MatDialog) {
    this.store.dispatch(loadAllBusinessUnits());
  }

  addBusinessUnit() {
    this.openBusinessUnitFormDialog();
  }

  editBusinessUnit(businessUnitId: string) {
    this.openBusinessUnitFormDialog(businessUnitId);
  }

  deleteBusinessUnit(businessUnitId: string) {
    this.store.dispatch(
      openDeleteConfirmationDialog({
        onConfirm: () => {
          this.store.dispatch(deleteBusinessUnit({ businessUnitId }));
        },
        description:
          'Are you sure you want to delete the selected business unit? You cannot undo this action.',
      })
    );
  }

  private openBusinessUnitFormDialog(businessUnitId: string | null = null) {
    const dialogRef = this.dialog.open(BusinessUnitDialogFormComponent, {
      panelClass: 'business-unit-form-dialog',
      closeOnNavigation: false,
      disableClose: true,
      maxWidth: 'unset',
      data: businessUnitId,
    });
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.closeWindow();
    });
  }
}
